import { createSlice } from '@reduxjs/toolkit'

export const authenticationReactive = createSlice({
  name: 'authentication',
  initialState: {
    value: {},
  },
  reducers: {
   
    livenessValidation: (state, action) => {
      state.value = { ...state.value, ...action.payload }
    },
  },
})

// Action creators are generated for each case reducer function
export const { livenessValidation } = authenticationReactive.actions

export default authenticationReactive.reducer;